var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fast-search-input" },
    [
      _c(
        "el-popover",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closeSearchResultPanel,
              expression: "closeSearchResultPanel"
            }
          ],
          attrs: {
            placement: "bottom-start",
            width: _vm.resultContentWidth,
            trigger: "manual",
            "popper-class": "p-0 fast-search-popover",
            value: _vm.displayResultPanel
          },
          on: { show: _vm.resultOpened },
          scopedSlots: _vm._u([
            {
              key: "reference",
              fn: function() {
                return [
                  _c("el-input", {
                    ref: "search-input",
                    attrs: {
                      "suffix-icon": "icon-search",
                      placeholder: _vm.fastSearchPlaceholderLabel
                    },
                    on: {
                      input: _vm.process,
                      focus: function($event) {
                        _vm.searchInputFocus = true
                      }
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "prelative",
                  staticStyle: { "min-height": "50px" }
                },
                [_c("preloader", { attrs: { display: _vm.loading } })],
                1
              )
            : _c("div", [
                _vm.allResult
                  ? _c("div", { staticClass: "wp-10 px-5 py-3 bb-1" }, [
                      _c(
                        "a",
                        {
                          staticClass: "link flex-level",
                          attrs: { href: "javascript:;" },
                          on: { click: _vm.process }
                        },
                        [
                          _c("i", { staticClass: "icon-chevron-left mr-2" }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$l10n.__("Retour à la liste"))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "py-3" },
                  [
                    _vm.noResult
                      ? _c(
                          "div",
                          { staticClass: "fast-search-no-result flex-level" },
                          [
                            _c("div", { staticClass: "wp-10 acenter" }, [
                              _c("div", { staticClass: "m-auto pb-4" }, [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "/ressources/logged/img/dashboard/no-result-illustration.svg",
                                    alt: "",
                                    width: "127"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "wp-7 m-auto wordbreak" },
                                [
                                  _c("span", { staticClass: "fs-3 gray-60" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Aucun résultat ne semble correspondre à votre recherche, modifiez votre critère."
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.contacts &&
                    _vm.contacts.items &&
                    _vm.contacts.items.length > 0
                      ? _c("search-result", {
                          attrs: {
                            data: _vm.contacts,
                            "all-result": _vm.allResult
                          },
                          on: { processByType: _vm.processByType },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("search-result-contact", {
                                      attrs: { data: data }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            220066896
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.individuals &&
                    _vm.individuals.items &&
                    _vm.individuals.items.length > 0
                      ? _c("search-result", {
                          staticClass: "mt-3",
                          attrs: {
                            data: _vm.individuals,
                            "all-result": _vm.allResult
                          },
                          on: { processByType: _vm.processByType },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("search-result-third", {
                                      attrs: { data: data }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            915495027
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.companies &&
                    _vm.companies.items &&
                    _vm.companies.items.length > 0
                      ? _c("search-result", {
                          staticClass: "mt-3",
                          attrs: {
                            data: _vm.companies,
                            "all-result": _vm.allResult
                          },
                          on: { processByType: _vm.processByType },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("search-result-third", {
                                      attrs: { data: data }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            915495027
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.opportunities &&
                    _vm.opportunities.items &&
                    _vm.opportunities.items.length > 0
                      ? _c("search-result", {
                          staticClass: "mt-3",
                          attrs: {
                            data: _vm.opportunities,
                            "all-result": _vm.allResult
                          },
                          on: { processByType: _vm.processByType },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("search-result-opportunity", {
                                      attrs: { data: data }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            269136329
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasDocumentSearch
                      ? _c("search-result", {
                          staticClass: "mt-3",
                          attrs: {
                            data: _vm.documentsData,
                            "all-result": _vm.allResult,
                            "group-by": _vm.salesDocuments.groupBy
                          },
                          on: { processByType: _vm.processByType },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("search-result-sales-document", {
                                      attrs: { data: data }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3099633146
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.products &&
                    _vm.products.items &&
                    _vm.products.items.length > 0
                      ? _c("search-result", {
                          staticClass: "mt-3",
                          attrs: {
                            data: _vm.products,
                            "all-result": _vm.allResult
                          },
                          on: { processByType: _vm.processByType },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("search-result-product", {
                                      attrs: { data: data }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1077750875
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tickets &&
                    _vm.tickets.items &&
                    _vm.tickets.items.length > 0
                      ? _c("search-result", {
                          staticClass: "mt-3",
                          attrs: {
                            data: _vm.tickets,
                            "all-result": _vm.allResult
                          },
                          on: { processByType: _vm.processByType },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("search-result-support", {
                                      attrs: { data: data }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1495215839
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.archived &&
                    _vm.archived.items &&
                    _vm.archived.items.length > 0
                      ? _c("search-result", {
                          staticClass: "mt-3",
                          attrs: { data: _vm.archived, "all-result": true },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("span", { staticClass: "red" }, [
                                      _vm._v(_vm._s(data.label))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "content",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c(data.component, {
                                      tag: "component",
                                      attrs: { data: data }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3153958104
                          )
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }